import React from "react";
import { formatDateTime } from "../utils/textUtils";
import circleLogo from "../assets/circleLogo.png";

interface MaintenanceMessageProps {
  message?: string;
  endDateTime?: string;
}

/**
 * Overlay component displayed when the system is in maintenance mode or has scheduled maintenance
 * Shows as an overlay on top of the existing page content
 */
const MaintenanceMessage: React.FC<MaintenanceMessageProps> = ({
  message,
  endDateTime,
}) => {
  // Date formatting options for detailed display
  const dateTimeOptions: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  };

  /**
   * Get the default message based on maintenance type
   */
  const getDefaultMessage = (): string => {
    return "The Aveta assistant is currently undergoing maintenance.";
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12 animate-fade-in">
        {/* Logo Area */}
        <div className="flex justify-center mb-6">
          <div className="bg-[#00a8ca] shadow-lg rounded-full p-6">
            <img
              src={circleLogo}
              alt="Aveta Assistant"
              className="h-16 w-16 object-contain"
            />
          </div>
        </div>

        {/* Title */}
        <h1
          className="text-3xl md:text-4xl font-bold text-center mb-4"
          style={{ color: "#46ACC6" }}
        >
          System Maintenance
        </h1>

        <p className="text-lg text-gray-600 text-center mb-6">
          {message || getDefaultMessage()}{" "}
          {endDateTime && (
            <>
              Service is expected to resume{" "}
              {formatDateTime(endDateTime, dateTimeOptions)}.{" "}
            </>
          )}
          We apologize for any inconvenience. Please check back shortly.
        </p>
      </div>
    </div>
  );
};

export default MaintenanceMessage;
